// extracted by mini-css-extract-plugin
export default {"stuffList":"style_stuffList__dvee8"};